module.exports = __webpack_public_path__ + "img/devices-communicator.fe97287b.png";